'use strict';

var $window = $(window);

/* smartresize
================================================== */
(function($,sr){

	// debouncing function from John Hann
	// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
	var debounce = function (func, threshold, execAsap) {
		var timeout;

		return function debounced () {
			var obj = this, args = arguments;
			function delayed () {
					if (!execAsap)
							func.apply(obj, args);
					timeout = null;
			};

			if (timeout)
					clearTimeout(timeout);
			else if (execAsap)
					func.apply(obj, args);

			timeout = setTimeout(delayed, threshold || 100);
		};
	}
	// smartresize 
	jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };
})(jQuery,'smartresize');

/* slider
================================================== */
function _slider ()
{
	var slider = $('#slider'),
		target = $('[data-slide-target]'),
		assistant = $('#assistant'),
		progress = $('#progress'),
		d1 = progress.children('.dot--first'),
		d2 = progress.children('.dot--second'),
		d3 = progress.children('.dot--third');

	slider.carousel({
		wrap: false,
		interval: false
	});

	target
	.one('click', function (e) {
		e.preventDefault();

		progress.addClass('visible');
	})
	.on('click', function (e) {
		e.preventDefault();

		var $this = $(this),
			_target = parseInt($this.data('slide-target'));

		slider.carousel(_target);

		if ( _target===1 )
		{
			d1.addClass('active').removeClass('success');
			d2.removeClass('active');

			// assistant.removeClass('visible');

			$(document.body).removeClass('assistant-visible');
		};

		if ( _target===2 || _target===3 )
		{
			d1.removeClass('active').addClass('success');
			d2.addClass('active');

			// assistant.addClass('visible');

			$(document.body).addClass('assistant-visible');
		};

		if ( _target===4 )
		{
			d2.removeClass('active').addClass('success');
			d3.addClass('active');
		};
	});
}

/* countdown
================================================== */
function _countdown ()
{
	var countdown = $('#countdown'),
		countdown2 = $('#countdown-2'),
		endDate = "01 9, 2017 15:03:25",
		time = new Date(Date.now() + 1000 * 60 * 60 * 1.76);

	countdown.countdown({
		date: time,
		render: function(data) {
			$(this.el).html("<div><span>" + this.leadingZeros(data.hours, 2) + "</span><span>Hours</span></div><div><span>" + this.leadingZeros(data.min, 2) + "</span><span>minutes</span></div>");
		}
	});

	countdown2.countdown({
		date: time,
		render: function(data) {
			$(this.el).html("<span>" + this.leadingZeros(data.hours, 1) + "</span><span>" + this.leadingZeros(data.min, 2) + "</span>");
		}
	});
};

/* person count
================================================== */
function _person_count ()
{
	var btn_minus = $('#minus-value'),
		btn_plus  = $('#plus-value'),
		input = $('#textfield__persons'),
		val = 1;

	btn_plus.click(function (e)
	{
		var input_val = parseInt(input.val()) || 0;

		input.val(input_val + 1);
		input.change();
		return false;
	});

	btn_minus.click(function (e)
	{
		var count = ( parseInt(input.val()) || 0 ) - 1;

		count = count < 1 ? 1 : count;
		input.val(count);
		input.change();
		return false;
	});
};

$(document).ready(function() {

	/* slider
	================================================== */
	 _slider();

	/* countdown
	================================================== */
	_countdown();

	/* person count
	================================================== */
	_person_count();
});

$window.on('load', function () {

	var n_app = document.getElementById('app'),
		j_app = $(n_app);

	j_app.css("height", $window.outerHeight(true));

	$window.smartresize(function() {
		j_app.css("height", $window.outerHeight(true));
	});
});